import { useState, useEffect } from 'react';

interface StringData {
  header: {
    email: string;
    phone: string;
    followUs: string;
  };
  navigation: {
    companyName: string;
    companyTagline: string;
    home: string;
    products: string;
    services: string;
    about: string;
    contact: string;
    renewableEnergy: string;
    solarPanels: string;
    windEnergy: string;
    batteries: string;
  };
  topBar: {
    logoAlt: string;
    companyName: string;
    companyTagline: string;
    home: string;
    products: string;
    services: string;
    trainings: string;
    projects: string;
    about: string;
    contact: string;
    solarEnergy: string;
    materials: string;
    solarPanels: string;
    inverters: string;
    batteries: string;
    structures: string;
    solarCables: string;
    ledLighting: string;
    domotics: string;
    antennas: string;
    seeAllProducts: string;
    cartLimit: string;
    myProfile: string;
    logout: string;
    login: string;
    myProfileMobile: string;
    logoutMobile: string;
    loginMobile: string;
  };
  heroBanner: {
    title: string;
    titleHighlight: string;
    titleContinuation: string;
    subtitle: string;
    exploreProductsButton: string;
  };
  featuredProducts: {
    title: string;
    titleHighlight: string;
    subtitle: string;
    imagePlaceholder: string;
    addButton: string;
    viewAllButton: string;
  };
  featuredServices: {
    title: string;
    titleHighlight: string;
    subtitle: string;
    requestQuoteButton: string;
  };
  courses: {
    title: string;
    titleHighlight: string;
    subtitle: string;
    imagePlaceholder: string;
    certified: string;
    enrollButton: string;
    viewAllButton: string;
  };
  infoBanner: {
    cleanEnergyTitle: string;
    cleanEnergyText: string;
    certificationsTitle1: string;
    certificationsTitle2: string;
    certificationsText: string;
    supportTitle1: string;
    supportTitle2: string;
    supportText: string;
  };
  footer: {
    companyName: string;
    companyTagline: string;
    description: string;
    email: string;
    phone: string;
    location: string;
    quickLinks: string;
    home: string;
    products: string;
    services: string;
    about: string;
    contact: string;
    servicesTitle: string;
    solarInstallation: string;
    maintenance: string;
    consulting: string;
    training: string;
    support247: string;
    copyright: string;
  };
  about: {
    heroTitle: string;
    heroSubtitle: string;
    missionTitle: string;
    missionText: string;
    visionTitle: string;
    visionText: string;
    valuesTitle: string;
    qualityTitle: string;
    qualityText: string;
    commitmentTitle: string;
    commitmentText: string;
    innovationTitle: string;
    innovationText: string;
    sustainabilityTitle: string;
    sustainabilityText: string;
    teamTitle: string;
    teamSubtitle: string;
    teamMemberName: string;
    teamJobTitle: string;
    teamDescription: string;
  };
  contact: {
    heroTitle: string;
    heroSubtitle: string;
    contactInfoTitle: string;
    emailLabel: string;
    primaryEmail: string;
    salesEmail: string;
    phoneLabel: string;
    primaryPhone: string;
    secondaryPhone: string;
    addressLabel: string;
    address: string;
    scheduleLabel: string;
    weekdaySchedule: string;
    saturdaySchedule: string;
    sundaySchedule: string;
    mapPlaceholder: string;
    formTitle: string;
    fullNameLabel: string;
    emailFieldLabel: string;
    phoneFieldLabel: string;
    subjectLabel: string;
    messageLabel: string;
    subjectPlaceholder: string;
    quoteOption: string;
    generalInfoOption: string;
    technicalSupportOption: string;
    trainingOption: string;
    messagePlaceholder: string;
    sendButton: string;
  };
  auth: {
    login: {
      title: string;
      subtitle: string;
      emailLabel: string;
      passwordLabel: string;
      emailPlaceholder: string;
      passwordPlaceholder: string;
      rememberMe: string;
      forgotPassword: string;
      loginButton: string;
      loggingIn: string;
      noAccount: string;
      registerHere: string;
      demoTitle: string;
      demoEmail: string;
      demoPassword: string;
    };
    register: {
      title: string;
      subtitle: string;
      fullNameLabel: string;
      emailLabel: string;
      phoneLabel: string;
      companyLabel: string;
      passwordLabel: string;
      confirmPasswordLabel: string;
      fullNamePlaceholder: string;
      emailPlaceholder: string;
      phonePlaceholder: string;
      companyPlaceholder: string;
      passwordPlaceholder: string;
      confirmPasswordPlaceholder: string;
      acceptTerms: string;
      termsAndConditions: string;
      and: string;
      privacyPolicy: string;
      createButton: string;
      creatingAccount: string;
      haveAccount: string;
      loginHere: string;
    };
  };
  cart: {
    title: string;
    emptyTitle: string;
    emptyDescription: string;
    exploreProductsButton: string;
    product: string;
    products: string;
    productHeader: string;
    priceHeader: string;
    quantityHeader: string;
    subtotalHeader: string;
    actionsHeader: string;
    stockWarning: string;
    removeTooltip: string;
    clearCartButton: string;
    continueShoppingLink: string;
    orderSummaryTitle: string;
    subtotalLabel: string;
    shippingLabel: string;
    freeShipping: string;
    taxLabel: string;
    totalLabel: string;
    checkoutButton: string;
    securePayment: string;
    freeShippingLima: string;
    satisfactionGuarantee: string;
  };
  productList: {
    heroTitle: string;
    heroSubtitle: string;
    filtersTitle: string;
    searchLabel: string;
    searchPlaceholder: string;
    categoryLabel: string;
    priceRangeLabel: string;
    productsFound: string;
    sortByName: string;
    sortByPrice: string;
    sortByRating: string;
    imagePlaceholder: string;
    addButton: string;
    stockWarning: string;
    noProductsFound: string;
    categories: {
      all: string;
      solarPanels: string;
      inverters: string;
      batteries: string;
      cables: string;
      lighting: string;
      domotics: string;
      antennas: string;
    };
  };
  checkout: {
    emptyCartTitle: string;
    goToProductsButton: string;
    successMessage: string;
    backToCartLink: string;
    title: string;
    totalToPay: string;
    shippingStep: string;
    paymentStep: string;
    confirmationStep: string;
    shippingInfoTitle: string;
    nameLabel: string;
    lastNameLabel: string;
    emailLabel: string;
    phoneLabel: string;
    addressLabel: string;
    districtLabel: string;
    cityLabel: string;
    postalCodeLabel: string;
    selectDistrict: string;
    addressPlaceholder: string;
    continueToPayment: string;
    paymentMethodTitle: string;
    selectPaymentMethod: string;
    creditCard: string;
    bankTransfer: string;
    cashOnDelivery: string;
    cardNumberLabel: string;
    cardHolderLabel: string;
    expiryDateLabel: string;
    cvvLabel: string;
    cardNumberPlaceholder: string;
    cardHolderPlaceholder: string;
    expiryPlaceholder: string;
    cvvPlaceholder: string;
    backButton: string;
    reviewOrderButton: string;
    orderConfirmationTitle: string;
    shippingAddressTitle: string;
    paymentMethodDisplayTitle: string;
    processingButton: string;
    confirmOrderButton: string;
    orderSummaryTitle: string;
    quantityLabel: string;
    subtotalLabel: string;
    shippingLabel: string;
    freeShipping: string;
    taxLabel: string;
    totalLabel: string;
    securePayment: string;
    dataProtection: string;
    districts: {
      ate: string;
      barranco: string;
      brena: string;
      callao: string;
      chorrillos: string;
      jesus_maria: string;
      la_molina: string;
      lince: string;
      magdalena: string;
      miraflores: string;
      pueblo_libre: string;
      san_borja: string;
      san_isidro: string;
      san_miguel: string;
      santa_anita: string;
      santiago_surco: string;
    };
  };
  profile: {
    personalInfoTitle: string;
    nameLabel: string;
    emailLabel: string;
    phoneLabel: string;
    companyLabel: string;
    notSpecified: string;
    logoutButton: string;
    myOrdersTitle: string;
    myCoursesTitle: string;
    noOrdersMessage: string;
    noCoursesMessage: string;
    progressLabel: string;
    enrolledLabel: string;
    orderStatus: {
      delivered: string;
      processing: string;
      pending: string;
      cancelled: string;
    };
    courseStatus: {
      completed: string;
      inProgress: string;
    };
  };
  notFound: {
    errorCode: string;
    title: string;
    message: string;
    homeButton: string;
    backButton: string;
    attemptedRoute: string;
  };
  productCard: {
    imagePlaceholder: string;
    newBadge: string;
    availableBadge: string;
    consultBadge: string;
    quickView: string;
    viewMore: string;
    share: string;
    addToCart: string;
    contactForPrice: string;
  };
  common: {
    loading: string;
    error: string;
    success: string;
  };
  errors: {
    loginIncorrect: string;
    loginError: string;
    passwordMismatch: string;
    passwordTooShort: string;
    acceptTermsRequired: string;
    createAccountError: string;
    registerError: string;
  };
  app: {
    notFoundCode: string;
    notFoundTitle: string;
    notFoundMessage: string;
    backToHomeButton: string;
  };
  infoEmpresa:{
    correos: {
      gerencia: string;
      ventas: string;
    };
    telefonos: {
      atencion: string;
      ventas: string;
    }
    direccion: string;
  };
}

export const useStrings = () => {
  const [strings, setStrings] = useState<StringData | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const loadStrings = async () => {
      try {
        const response = await fetch('/values/strings.json');
        if (!response.ok) {
          throw new Error('Failed to load strings');
        }
        const data = await response.json();
        setStrings(data);
      } catch (err) {
        setError(err instanceof Error ? err.message : 'Unknown error');
      } finally {
        setLoading(false);
      }
    };

    loadStrings();
  }, []);

  return { strings, loading, error };
};